import React from "react";

/**
 * Wraps case-insensitive matches of `query` in <mark> for inbox search UX.
 * @param {string | number | null | undefined} text
 * @param {string} query
 * @returns {React.ReactNode}
 */
export function highlightSearchText(text, query) {
  const s = text == null ? "" : String(text);
  const q = query.trim();
  if (!q) return s || "—";

  const lower = s.toLowerCase();
  const ql = q.toLowerCase();
  const parts = [];
  let i = 0;
  let key = 0;
  let idx = lower.indexOf(ql, i);

  while (idx !== -1) {
    if (idx > i) {
      parts.push(<React.Fragment key={key++}>{s.slice(i, idx)}</React.Fragment>);
    }
    parts.push(
      <mark key={key++} className="admin-dash__search-hit">
        {s.slice(idx, idx + q.length)}
      </mark>
    );
    i = idx + q.length;
    idx = lower.indexOf(ql, i);
  }
  if (i < s.length) {
    parts.push(<React.Fragment key={key++}>{s.slice(i)}</React.Fragment>);
  }

  if (!parts.length) return s || "—";
  return parts;
}
